import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IPaymentData } from '../../interfaces/IPaymentData';
import { IOrder } from '../../interfaces/IOrder';
import { PaymentDataType } from '../../enums/PaymentDataType';

const apiUrl = Globals.apiPath + '/paymentData';

export default class PaymentDataService {
  constructor() {}

  async getAll(): Promise<IPaymentData[]> {
    let res = await axios.get<IPaymentData[]>(`${apiUrl}`);
    return res.data;
  }

  async create(paymentData: {
    type: PaymentDataType;
    country: string;
    data: any;
    tz?: number;
  }): Promise<IPaymentData> {
    let res = await axios.post<IPaymentData>(apiUrl, paymentData);
    return res.data;
  }

  async delete(paymentData: IPaymentData): Promise<IPaymentData> {
    let res = await axios.delete<IPaymentData>(`${apiUrl}/${paymentData.id}`);
    return res.data;
  }

  async setDefault(paymentData: IPaymentData): Promise<IPaymentData> {
    let res = await axios.post<IPaymentData>(
      `${apiUrl}/${paymentData.id}/setDefault`
    );
    return res.data;
  }

  async unsetDefault(paymentData: IPaymentData): Promise<IPaymentData> {
    let res = await axios.post<IPaymentData>(
      `${apiUrl}/${paymentData.id}/unsetDefault`
    );
    return res.data;
  }
}
